/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type reportedTimeComponentRefetchQueryVariables = {
    shareKey?: string | null | undefined;
    clientId?: string | null | undefined;
    personId?: string | null | undefined;
    projectId?: string | null | undefined;
    isProjectGroupType?: boolean | null | undefined;
    dateCriteria?: string | null | undefined;
    groupBy?: string | null | undefined;
    projectIds?: Array<string | null> | null | undefined;
    billableFilterValue?: boolean | null | undefined;
    personIds?: Array<string | null> | null | undefined;
    departmentIds?: Array<string | null> | null | undefined;
    teamIds?: Array<string | null> | null | undefined;
    roleIds?: Array<string | null> | null | undefined;
    labelIds?: Array<string | null> | null | undefined;
    skillIds?: Array<string | null> | null | undefined;
    componentId?: string | null | undefined;
};
export type reportedTimeComponentRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"reportedTimeComponent_viewer">;
    } | null;
};
export type reportedTimeComponentRefetchQuery = {
    readonly response: reportedTimeComponentRefetchQueryResponse;
    readonly variables: reportedTimeComponentRefetchQueryVariables;
};



/*
query reportedTimeComponentRefetchQuery(
  $shareKey: String
  $clientId: ID
  $personId: ID
  $projectId: ID
  $isProjectGroupType: Boolean
  $dateCriteria: String
  $groupBy: String
  $projectIds: [ID]
  $billableFilterValue: Boolean
  $personIds: [ID]
  $departmentIds: [ID]
  $teamIds: [ID]
  $roleIds: [ID]
  $labelIds: [ID]
  $skillIds: [ID]
  $componentId: ID
) {
  viewer {
    ...reportedTimeComponent_viewer_1UO2N4
    id
  }
}

fragment reportedTimeComponent_viewer_1UO2N4 on Viewer {
  insightComponentsData(shareKey: $shareKey) {
    reportedTimeList(projectId: $projectId, isProjectGroupType: $isProjectGroupType, clientId: $clientId, personId: $personId, dateCriteria: $dateCriteria, groupBy: $groupBy, projectIds: $projectIds, billableFilterValue: $billableFilterValue, personIds: $personIds, departmentIds: $departmentIds, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, skillIds: $skillIds, componentId: $componentId) {
      id
      currency
      timeRegistrations {
        id
        personName
        departmentName
        projectName
        roleNameOrNonProjTime
        taskNameOrNonProjTime
        groupingElementName
        minutesRegistered
        dateYear
        dateMonth
        dateDay
        price
        cost
        billable
        notes
        clientName
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shareKey",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isProjectGroupType",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateCriteria",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupBy",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "billableFilterValue",
    "type": "Boolean"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "departmentIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roleIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labelIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skillIds",
    "type": "[ID]"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "componentId",
    "type": "ID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "billableFilterValue",
  "variableName": "billableFilterValue"
},
v2 = {
  "kind": "Variable",
  "name": "clientId",
  "variableName": "clientId"
},
v3 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v4 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v5 = {
  "kind": "Variable",
  "name": "departmentIds",
  "variableName": "departmentIds"
},
v6 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v7 = {
  "kind": "Variable",
  "name": "isProjectGroupType",
  "variableName": "isProjectGroupType"
},
v8 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v9 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v10 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v11 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v12 = {
  "kind": "Variable",
  "name": "projectIds",
  "variableName": "projectIds"
},
v13 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v14 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v15 = {
  "kind": "Variable",
  "name": "skillIds",
  "variableName": "skillIds"
},
v16 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reportedTimeComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "reportedTimeComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reportedTimeComponentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v14/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "concreteType": "ReportedTimeList",
                "kind": "LinkedField",
                "name": "reportedTimeList",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportedTimeListTimeRegType",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "departmentName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleNameOrNonProjTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskNameOrNonProjTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "groupingElementName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "price",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cost",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "reportedTimeComponentRefetchQuery",
    "operationKind": "query",
    "text": "query reportedTimeComponentRefetchQuery(\n  $shareKey: String\n  $clientId: ID\n  $personId: ID\n  $projectId: ID\n  $isProjectGroupType: Boolean\n  $dateCriteria: String\n  $groupBy: String\n  $projectIds: [ID]\n  $billableFilterValue: Boolean\n  $personIds: [ID]\n  $departmentIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n  $skillIds: [ID]\n  $componentId: ID\n) {\n  viewer {\n    ...reportedTimeComponent_viewer_1UO2N4\n    id\n  }\n}\n\nfragment reportedTimeComponent_viewer_1UO2N4 on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    reportedTimeList(projectId: $projectId, isProjectGroupType: $isProjectGroupType, clientId: $clientId, personId: $personId, dateCriteria: $dateCriteria, groupBy: $groupBy, projectIds: $projectIds, billableFilterValue: $billableFilterValue, personIds: $personIds, departmentIds: $departmentIds, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, skillIds: $skillIds, componentId: $componentId) {\n      id\n      currency\n      timeRegistrations {\n        id\n        personName\n        departmentName\n        projectName\n        roleNameOrNonProjTime\n        taskNameOrNonProjTime\n        groupingElementName\n        minutesRegistered\n        dateYear\n        dateMonth\n        dateDay\n        price\n        cost\n        billable\n        notes\n        clientName\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '2e0c9f724964d7b149fb70d9c0d2054d';
export default node;
